<template>
  <span
    class="ui-status-badge"
    :class="[`ui-status-badge--${resolvedVariant}`, { 'ui-status-badge--clickable': clickable }, customClass]"
    role="status"
    @click="handleClick"
  >
    <slot>{{ displayLabel }}</slot>
  </span>
</template>

<script>
const DEFAULT_VARIANTS = {
  success: ['paid', 'completed', 'active', 'approved', 'success'],
  warning: ['pending', 'partial', 'draft', 'warning'],
  danger: ['overdue', 'failed', 'cancelled', 'rejected', 'error', 'inactive'],
  info: ['open', 'sent', 'processing', 'info'],
  neutral: ['closed', 'unknown', 'neutral'],
};

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    displayLabel() {
      if (this.label) return this.label;
      if (!this.status) return '';
      return this.status
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
    resolvedVariant() {
      if (this.variant) return this.variant;
      const normalized = String(this.status || '').toLowerCase();
      for (const [variant, values] of Object.entries(DEFAULT_VARIANTS)) {
        if (values.includes(normalized)) return variant;
      }
      return 'neutral';
    },
  },
  methods: {
    handleClick(event) {
      if (!this.clickable) return;
      this.$emit('click', event);
    },
  },
};
</script>

<style src="../styles/StatusBadge.css"></style>
